import { __decorate, __extends } from "tslib";
import { _GraphQueryableCollection, _GraphQueryableInstance, _GraphQueryableSearchableCollection, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath, getById, addable, updateable } from "../decorators.js";
/**
 * Message
 */
var _Message = /** @class */ (function (_super) {
    __extends(_Message, _super);
    function _Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return _Message;
}(_GraphQueryableInstance));
export { _Message };
export var Message = graphInvokableFactory(_Message);
/**
 * Messages
 */
var _Messages = /** @class */ (function (_super) {
    __extends(_Messages, _super);
    function _Messages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Messages = __decorate([
        defaultPath("messages"),
        getById(Message),
        addable()
    ], _Messages);
    return _Messages;
}(_GraphQueryableSearchableCollection));
export { _Messages };
export var Messages = graphInvokableFactory(_Messages);
/**
 * MailFolder
 */
var _MailFolder = /** @class */ (function (_super) {
    __extends(_MailFolder, _super);
    function _MailFolder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return _MailFolder;
}(_GraphQueryableInstance));
export { _MailFolder };
export var MailFolder = graphInvokableFactory(_MailFolder);
/**
 * MailFolders
 */
var _MailFolders = /** @class */ (function (_super) {
    __extends(_MailFolders, _super);
    function _MailFolders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _MailFolders = __decorate([
        defaultPath("mailFolders"),
        getById(MailFolder),
        addable()
    ], _MailFolders);
    return _MailFolders;
}(_GraphQueryableCollection));
export { _MailFolders };
export var MailFolders = graphInvokableFactory(_MailFolders);
/**
 * MailboxSettings
 */
var _MailboxSettings = /** @class */ (function (_super) {
    __extends(_MailboxSettings, _super);
    function _MailboxSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _MailboxSettings = __decorate([
        defaultPath("mailboxSettings"),
        updateable()
    ], _MailboxSettings);
    return _MailboxSettings;
}(_GraphQueryableInstance));
export { _MailboxSettings };
export var MailboxSettings = graphInvokableFactory(_MailboxSettings);
//# sourceMappingURL=types.js.map